import { useState } from "react";
import styled from "styled-components";

const Project = ({ item, handleClick }) => {
  const [activated, setActivated] = useState(false);

  return (
    <StyledProject
      onClick={handleClick}
      onMouseEnter={() => setActivated(true)}
      onMouseLeave={() => setActivated(false)}
      activated={activated}
    >
      <ProjectHeader>
        <ImageContainer>
          <Image src={item.img} alt="projImg" />
        </ImageContainer>
        <div>
          <sub>{item.status}</sub>
          <h1>{item.name}</h1>
          <h3>{item.sector}</h3>
        </div>
      </ProjectHeader>
      <ProjectSection>
        <h3>Role</h3>
        <p>{item.role}</p>
        <h3>What</h3>
        <p>{item.description}</p>
      </ProjectSection>
    </StyledProject>
  );
};

export default Project;

const StyledProject = styled.div`
  width: clamp(300px, 333px, 2rem);
  height: 320px;
  /* background-color: ${({ activated, theme }) =>
    activated ? theme.hover : null}; */
  padding: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  margin: 1rem 0px;

  &:hover {
    background-color: ${({ theme }) => theme.hover};
    cursor: pointer;
    transform: translateY(-2px);
  }
`;

const ProjectHeader = styled.header`
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);

  h1 {
    font-size: 1.2rem;
    font-weight: 400;
    margin: 5px 0px;
  }

  sub {
    color: orange;
  }
`;

const ImageContainer = styled.div`
  border-radius: 4px;
  overflow: hidden;
  margin-right: 24px;
`;

const Image = styled.img`
  width: 56px;
  height: 56px;
`;

const ProjectSection = styled.section`
  height: 192px;

  h3 {
    font-weight: bold;
    margin: 12px 0px;
  }

  p {
    margin: 2px;
  }
`;
